import { any } from "ramda";
import { Fragment } from "react";
import { RadioButton } from "../../common/RadioButton";
import { ChartLegend, ChartLegendProps } from "./ChartLegend";

export const ChartLegendList = ({
  curveProps,
  radioList = false,
  showText = false,
  unSelectedCurves = [],
  onChange = () => {},
}: {
  curveProps: (ChartLegendProps & { dataKey?: string })[];
  radioList?: boolean;
  showText?: boolean;
  unSelectedCurves?: string[];
  onChange?: (curveName: string) => void;
}) => {
  return (
    <div className="h-full flex flex-col justify-center mr-2">
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `max-content ${radioList ? "max-content" : ""}`,
          gridGap: "1rem",
        }}
      >
        {curveProps.map((curve) => {
          return (
            <Fragment key={curve.dataKey}>
              <ChartLegend
                icon={curve.icon}
                color={curve.color}
                strokeDashArray={curve.strokeDashArray}
                text={curve.text}
              />
              {radioList && (
                <RadioButton
                  onClick={() => {
                    curve.dataKey
                      ? onChange(curve.dataKey)
                      : console.warn(
                          "You must provide a dataKey prop to use radio button"
                        );
                  }}
                  size="xl"
                  selected={!any((s) => s === curve.dataKey, unSelectedCurves)}
                />
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};
